
export const productRemoveSuccess = () =>{
    return {
        type : 'PRODUCT_REMOVE_SUCCESS'
    }
}
export const productRemoveFail = () => {
    return {
        type : 'PRODUCT_REMOVE_FAIL'
    }
}


export const editProduct = (id) => {
    return {
        type : 'EDIT_PRODUCT',
        payload : {
            id
        }
    }
}

export const editProductSuccess = () => {
    return {
        type : 'EDIT_PRODUCT_SUCCESS'
    }
}

export const editProductFail = ()=> {
    return {
        type : 'EDIT_PRODUCT_FAIL'
    }
}

export const updateEditingInfo = (name, value)=> {
    return {
        type : 'UPDATE_EDITING_INFO',
        payload : {
            name,
            value
        }
    }
}

export const updateProduct = (info) => {
    return (dispatch, getState, getFirebase) => {
        const {id, name, category, description, prices, types, order} = info
        const firebase = getFirebase();
        const productRef = firebase.ref().child(`products/${id}`);
        //do update
        productRef.update({
            name,
            category,
            description,
            prices,
            types,
            order,
        }, ()=> {
            console.log('update success');
        })
            .catch((error)=>{
                dispatch(editProductFail());
            })
    }
}
export const updateProductImage = (id, file, completeFunc) => {
    return (dispatch, getState, getFirebase) => {
        const firebase = getFirebase();
        const productImageRef = firebase.storage().ref(`product_images/${id}.jpg`);    
        productImageRef.delete()
            .then(() => {
                const task = productImageRef.put(file);
                task.on('state_changed', 
                    (snapshot) => {
                        const percentage = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                    },
                    (e) => {
                        console.log(e);
                    },
                    ()=>{
                        completeFunc();
                    })
            })
            .catch((e) => {
                const task = productImageRef.put(file);
                task.on('state_changed', 
                    (snapshot) => {
                        const percentage = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                    },
                    (e) => {
                        console.log(e);
                    },
                    ()=>{
                        completeFunc();
                    })
            })
    }
}

export const productRegisterSuccess = () => {
    return {
        type : 'PRODUCT_REGISTER_SUCCESS'
    }
}

export const productRegisterFail = ()=> {
    return {
        type : 'PRODUCT_REGISTER_SUCCESS'
    }
}

export const registerProduct = (info) => {
    return (dispatch, getState, getFirebase) => {

        const { category, name, description, prices, types, order, file } = info

        const firebase = getFirebase();
        const productsRef = firebase.ref().child('products/');

        const productRef = productsRef.push();

        const productImageRef = firebase.storage().ref(`product_images/${productRef.key}.jpg`);
        const task = productImageRef.put(file);
        task.on('state_changed',
            (snapshot) => {
                const percentage = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            },
            (e) => {
                console.log(e);
            },
            () => {
                productRef.update({
                    category,
                    name,
                    description,
                    prices,
                    types,
                    order,
                }, () => {
                    global.alert("상품 등록을 완료했습니다.");
                })
            })
    }
}

export const removeProduct = (id, mainCategory, subCategory) => {
    return (dispatch, getState, getFirebase) => {
        const result = global.confirm('정말로 삭제하시겠습니까?');
        if(result) {
            const firebase = getFirebase();
            const databaseRef = firebase.ref().child('products/');
            const dataRef = firebase.ref().child(`products/${id}`);
            dataRef.update({
                category : {
                    mainCategory  : -2,
                    subCategory : -2
                }
            }, () => {
                let filteredProducts = getState().products.filter((product, filterIndex) => {
                    if(product.category.mainCategory === mainCategory && 
                        product.category.subCategory === subCategory) {
                        return true;
                    }
                });

                    console.log(filteredProducts);

                for(let i = 0; i < filteredProducts.length; ++i) {
                    databaseRef.child(`${filteredProducts[i].id}`).update({
                        order : i
                    })
                }
            });

            // productRef.remove()
            //     .then( ()=> {
            //         const productImageRef = firebase.storage().ref(`product_images/${productRef.key}.jpg`);
            //         productImageRef.delete()
            //             .then(() => {
            //                 dispatch(productRemoveSuccess());
            //             })
            //             .catch((e) => {
            //                 console.log(e);
            //                 dispatch(productRemoveFail());
            //             })
            //     })
            //     .catch((e)=> {
            //         console.log(e);
            //         dispatch(productRemoveFail());
            //     })
        }
    }
}

export const productOrderSwitch = (aGlobalIndex, bGlobalIndex) => {
    return (dispatch, getState, getFirebase) => {

        console.log(aGlobalIndex + ', ' + bGlobalIndex);

        const products = getState().products;
        
        const aProduct = products[aGlobalIndex];
        const bProduct = products[bGlobalIndex];

        //TODO : 나중에 정리 하면 Price를 복사하는걸 지우자
        let strippedA = {
            category: aProduct.category,
            description: aProduct.description,
            name: aProduct.name,
            order: aProduct.order,
            prices : aProduct.prices
        };
        if(aProduct.price) {
            strippedA['price'] = aProduct.price;
        }

        let strippedB = {
            category: bProduct.category,
            description: bProduct.description,
            name: bProduct.name,
            order: bProduct.order,
            prices : bProduct.prices
        };
        if(bProduct.price) {
            strippedB['price'] = bProduct.price;
        }

        const aOrder = aProduct.order;
        const bOrder = bProduct.order;

        strippedA.order = bOrder;
        strippedB.order = aOrder;

        const firebase = getFirebase();
        const productARef = firebase.ref().child(`products/${aProduct.id}`);
        productARef.update({
            ...strippedA
        });
        const productBRef = firebase.ref().child(`products/${bProduct.id}`);
        productBRef.update({
            ...strippedB
        })
    }
}


// WEBPACK FOOTER //
// ./src/pages/Admin/ProductManager/Category/Product/actions/productActions.js